export const rugby7sQualifikation2026MuenchenBerlin = {
  "id": "rugby-7s-qualifikation-2026-muenchen-berlin",
  "title": "Rugby 7s Qualifikation 2026 am 27. Juni 2026 in München und am 04.07. in Berlin (verlegt wegen Hitze, Datum noch in Prüfung)",
  "slug": "rugby-7s-qualifikation-2026-muenchen-berlin",
  "publishedAt": "2026-06-24T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "2 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "7er Rugby",
    "Qualifikation",
    "Deutsche Meisterschaft",
    "DIE FINALS",
    "München",
    "Berlin"
  ],
  "excerpt": "Am Samstag, den 27. Juni 2026, fällt die erste Teil-Entscheidung im Rennen um die letzten Startplätze für die Deutsche Meisterschaft im 7er Rugby. Die Qualifikation wird in Berlin und München ausgetragen. Das Berliner Turnier musste auf Grund der Hitzewelle auf den 04.07. verlegt werden, das genaue Datum befindet sich noch in Prüfung.",
  "img": "/images/rugby-7s-qualifikation-2026-muenchen-berlin.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Am Samstag, den 27. Juni 2026, fällt die erste Teil-Entscheidung im Rennen um die letzten Startplätze für die Deutsche Meisterschaft im 7er Rugby. Die Qualifikation wird in Berlin und München ausgetragen. Das Berliner Turnier musste auf Grund der Hitzewelle auf den 04.07. verlegt werden, das genaue Datum befindet sich noch in Prüfung. Die Teams kämpfen dabei um 4 begehrten Plätze beim nationalen Saisonhöhepunkt."
    },
    {
      "type": "paragraph",
      "content": "In den Qualifikationsturnieren treffen die Mannschaften auf starke Konkurrenz. Jeder Sieg kann entscheidend sein, denn nur die besten Teams werden sich den Traum von der Teilnahme an der Deutschen Meisterschaft erfüllen."
    },
    {
      "type": "paragraph",
      "content": "Alle Ergebnisse, Tabellen und Spielpläne können live unter folgendem Link verfolgt werden:"
    },
    {
      "type": "list",
      "items": [
        { "content": "Ergebnisse, Tabellen und Spielpläne (live)", "url": "https://www.rugbydeutschland.org/spiele-81794v4/leagues/12127/seasons/218" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Die jeweils zwei bestplatzierten Teams der Turniere in Berlin und München qualifizieren sich für DIE FINALS in Hannover. Dort werden am 23. Juli 2026 im Erika Fisch Stadion die Deutschen Meisterinnen und Deutschen Meister im 7er Rugby ermittelt. Die Wettkämpfe sind Teil des Multisportevents „Die Finals 2026“, das vom 23. bis 26. Juli in Hannover ausgetragen wird."
    }
  ]
};
